var App;

App = require('config/app');

module.exports = App.DocumentRoute = Ember.Route.extend({
  activate: function() {
    var title;
    title = this.modelFor('document').get('title');
    return document.title = "" + title + " - Poe";
  },
  actions: {
    save: function() {
      var model,
        _this = this;
      model = this.modelFor('document');
      model.set('updatedAt', new Date());
      return model.save().then(function() {
        return _this.transitionTo('documents');
      });
    },
    destroyRecord: function(record) {
      if (window.confirm('Are you sure you want to delete this document?')) {
        record.deleteRecord();
        if (record.currentState.stateName !== 'root.deleted.saved') {
          record.save();
        }
        return this.transitionTo('documents');
      }
    },
    downloadFile: function(record) {
      var blob, title;
      blob = new Blob([record.get('body')], {
        type: "text/plain;charset=utf-8"
      });
      title = record.get('title');
      if (!/.md|.mkdn?|.mdown|.markdown/.test(title)) {
        title += '.md';
      }
      return saveAs(blob, title);
    }
  }
});
